package Boostie.components.widgets

import Boostie.components.style.overlay
import Boostie.util.ColorUtils
import androidx.compose.runtime.Composable
import boostie.components.Resources
import boostie.components.Space
import boostie.components.style.MainColors
import boostie.components.style.NormalTextStyle
import boostie.components.style.RadiusMedium
import boostie.components.style.RadiusXXLarge
import boostie.components.style.RadiusXXXLarge
import boostie.components.style.SpaceLarge
import boostie.components.style.SpaceMedium
import boostie.components.style.SpaceSmall
import boostie.components.style.SpaceXSmall
import boostie.components.style.SpaceXXLarge
import boostie.components.style.SpaceXXSmall
import boostie.components.style.SpaceXXXLarge
import boostie.components.style.SubTitleStyle
import boostie.components.style.TitleStyle
import boostie.components.style.primaryDashedBorder
import boostie.components.style.textEllipsis
import boostie.components.widgets.SimpleDivider
import boostie.pages.sample.MobileTemplateSampleState
import boostie.pages.tags.views.CreatorPostTagView
import boostie.pages.tags.views.CreatorPostTagViewProps
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.color
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.overflowWrap
import com.varabyte.kobweb.compose.ui.modifiers.overflowX
import com.varabyte.kobweb.compose.ui.modifiers.overflowY
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBatteryHalf
import com.varabyte.kobweb.silk.components.icons.fa.FaSignal
import com.varabyte.kobweb.silk.components.icons.fa.FaWifi
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.shapes.Circle
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.clip
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.background
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.unaryMinus
import kotlin.random.Random

@Composable
fun CreatorProfileMobilePreviewView(modifier: Modifier = Modifier.height(630.px), state: MobileTemplateSampleState) {
    Box(
        modifier.minWidth(291.px).maxWidth(393.px)
            .backgroundColor(MainColors.background).clip(Rect(cornerRadius = RadiusXXXLarge))
            .borderRadius(RadiusXXXLarge).primaryDashedBorder
            .padding(SpaceXXSmall)
    ) {
        Box(
            modifier = Modifier.fillMaxSize()
                .clip(Rect(cornerRadius = RadiusXXXLarge))
                .overflow(Overflow.Auto)
        ) {
            Content(state)
        }
        Box(modifier = Modifier.fillMaxWidth().zIndex(1)) {
            StatusBarView()
        }
    }
}

@Composable
private fun Content(state: MobileTemplateSampleState) {
    Column(
        Modifier.fillMaxWidth()
            .borderRadius(RadiusXXXLarge)
            .overflowY(Overflow.Scroll),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        TopContent(modifier = Modifier.fillMaxWidth().borderRadius(topLeft = RadiusXXXLarge, topRight = RadiusXXXLarge), state = state)
        BottomContent(
            modifier = Modifier.fillMaxWidth().fillMaxHeight().borderRadius(bottomLeft = RadiusXXXLarge, bottomRight = RadiusXXXLarge)
                .margin(top = -SpaceLarge).clip(Rect(RadiusXXLarge)).styleModifier {
                    background(state.backgroundGradientColor)
                }, state = state
        )
    }
}

@Composable
private fun TopContent(modifier: Modifier, state: MobileTemplateSampleState) {
    Column(
        modifier
            .padding(leftRight = SpaceLarge, top = SpaceXXXLarge)
            .backgroundImage(url(state.backgroundPhotoUrl)).overlay()
    ) {
        Space(SpaceLarge)
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.Top) {
            val imageSize = 96.px
            Image(
                src = state.profilePhotoUrl,
                modifier = Modifier.size(imageSize).minWidth(imageSize).minHeight(imageSize).objectFit(ObjectFit.Cover).clip(Rect(RadiusMedium))
            )
            Space(SpaceMedium)
            Column(Modifier) {
                SpanText(
                    state.name, TitleStyle.toModifier().fillMaxWidth().styleModifier {
                        color(state.textPrimaryHexColor)
                    }.fontSize(1.5.cssRem).overflowWrap(
                        OverflowWrap.Anywhere
                    )
                )
                PropRowView(state, text = "XXX boosterů", icon = Resources.Icons.ic_subscriber_filled)
                Space(SpaceSmall)
                PropRowView(state, text = "X / měsíc", icon = Resources.Icons.ic_boostie_logo)

            }
        }
        Space()
        SpanText(state.bio, SubTitleStyle.toModifier().fillMaxWidth().styleModifier {
            color(state.textPrimaryHexColor)
        })
        Space()
        SpanText(state.description, SubTitleStyle.toModifier().fillMaxWidth().styleModifier {
            color(state.textPrimaryHexColor)
        }.textEllipsis(3))
        Space()
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End, verticalAlignment = Alignment.CenterVertically) {
            SpanText(
                "Více", SubTitleStyle.toModifier().color(state.textSecondaryRgbColor)
            )
        }
        Space()
        Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
            Row(
                Modifier.border(1.px, LineStyle.Solid, ColorUtils.parseColor(state.iconPrimaryHexColor)).backgroundColor(state.iconSecondaryRgbColor)
                    .padding(leftRight = SpaceLarge, topBottom = SpaceSmall).borderRadius(RadiusMedium),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
            ) {
                SvgImage(icon = Resources.Icons.ic_boostie_logo, color = state.iconPrimaryHexColor)
                Space()
                SpanText("Stat se boosterem", SubTitleStyle.toModifier().fillMaxWidth().fontWeight(FontWeight.Medium).styleModifier {
                    color(state.textPrimaryHexColor)
                })
            }
        }
        Space(SpaceXXLarge)
    }
}

@Composable
private fun BottomContent(modifier: Modifier, state: MobileTemplateSampleState) {
    Column(modifier) {
        Space()
        TagsRowView(state)
        Space(SpaceSmall)
        TextPostItemSample(state)
        AudioPostItemSample(state)

    }
}

@Composable
private fun TextPostItemSample(
    state: MobileTemplateSampleState,
    date: String = "Středa 17:47, 17.2. 2023",
    title: String = "Kdo může za drahé nemovitosti a vysokou inflaci? Vyhneme se vyšším daním? - Eva Zamrazilová ČNB",
    description: String = "Česká ekonomka, v letech 2008 až 2014 členka bankovní rady ČNB. Od ledna 2018 do června 2022 předsedala Národní rozpočtové radě, v letech 2014 až 2018 působila také jako hlavní ekonomka České bankovní asociace. Od roku 2022 je opět členkou bankovní rady ČNB a od července 2022 působí také jako viceguvernérka ČNB.\u2028\u2028\u2028\uD83D\uDD57 Časová osa\u2028\u20280:00 Partner pořadu.\u20280:19 Viceguvernérka České národní banky.\u202801:43 Jaký vliv má reálně ČNB na cenu nemovitostí.\u202804:38 Vlastní bydlení v dnešní době a úrokové sazby.\u202806:40 Výběr do bankovní rady.\u202808:35 Zodpovědnost Evy Zamrazilové.\u202810:54 Budou se letos snižovat úrokové sazby?\u202814:07 Mzdové tarify.\u202815:05 Inflace\u202818:04 Smysl České národní banky.\u202819:59 Proinflační fiskální politika.\u202821:24 Rozpočtová odpovědnost a vliv na inflaci.\u202824:48 Kvantitativní uvolňování\u202825:54 Budou se zvyšovat daně a proč?\u202827:42 Daň z nemovitosti část I.\u202828:48 Rozpočtové omezení.\u202830:21 Vysoká cena nemovitostí.\u202830:54 Sčítání lidu, domů a bytů.\u202833:27 Daň z nemovitosti část II.\u202834:33 Vyplatí se penzijní spoření?\u202837:25 Jak vyzrát na penzijní spoření? :)\u202838:14 Posun věku odchodu do důchodu. Půjdeme do důchodu ve 120ti letech?\u202841:20 Umělá inteligence a budoucnost.\u202842:40 Jak se Česká republika ekonomicky vyvíjí v rámci západních zemí.\u202847:27 Devizové rezervy v současnosti. \u202851:15 Jak vnímá bitcoin a kryptoměny Eva Zamrazilová.\u202851:55 Přechod na patreon.\u2028\u2028\u2028\uD83D\uDD17 Odkazy\u2028\u202802:06 https://cc.cz/author/vojta-zizka/\u202828:50    • VLASTNÍ 150 BYTŮ ...  \u202848:44 https://www.cnb.cz/cs/o_cnb/cnblog/Ja...\u2028\u2028\u2028\uD83C\uDFA5 Produkce\u2028\u2028\uD83D\uDC69\u200D\uD83E\uDDB0 Marcela Drobná https://www.instagram.com/animacina/\u2028\uD83D\uDC68 Martin Janeš https://www.instagram.com/themartinja...\u2028\uD83D\uDC68 Jiří Hořice https://www.linkedin.com/in/JiriHorice\u2028\u2028\u2028⚠️ Disclaimer\u2028\u2028Veškerá má tvorba slouží pouze ke studijním účelům. Není investičním poradenstvím, doporučením a také není nabídkou či výzvou k nákupu či prodeji finančních nástrojů. Mějte na paměti, že při investování či spekulaci s finančními instrumenty, hrozí ztráta části či všech finančních prostředků.",
) {
    Column(
        Modifier.fillMaxWidth().padding(leftRight = SpaceLarge, topBottom = SpaceSmall)
    ) {
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            SpanText(
                date,
                SubTitleStyle.toModifier().fillMaxWidth().whiteSpace(WhiteSpace.NoWrap).fontSize(0.75.cssRem).color(state.textSecondaryRgbColor)
            )
            Space(modifier = Modifier.fillMaxWidth())
            SvgImage(width = 40.px, icon = Resources.Icons.ic_dots, color = state.iconPrimaryHexColor)
        }
        SpanText(
            title,
            SubTitleStyle.toModifier().fillMaxWidth().fontWeight(FontWeight.Bold).color(state.textPrimaryHexColor).textEllipsis(2)
        )
        SpanText(
            description,
            SubTitleStyle.toModifier().fillMaxWidth().whiteSpace(WhiteSpace.NoWrap).fontSize(14.px).color(state.textSecondaryRgbColor).textEllipsis(3)
        )
        Space(SpaceSmall)
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            CommentsCount(iconColor = state.iconPrimaryHexColor, textColor = state.textSecondaryRgbColor, Random(100).nextInt(2, 100))
            Space(SpaceSmall)
            ReactionsCount(textColor = state.textSecondaryRgbColor, state.reactionEmojiUnicode, Random(100).nextInt(2, 10_000))
        }
        SimpleDivider(color = state.separatorRgbColor)
    }
}

@Composable
private fun AudioPostItemSample(
    state: MobileTemplateSampleState,
    date: String = "Středa 17:47, 17.2. 2023",
    title: String = "Kdo může za drahé nemovitosti a vysokou inflaci? Vyhneme se vyšším daním? - Eva Zamrazilová ČNB",
    description: String = "Česká ekonomka, v letech 2008 až 2014 členka bankovní rady ČNB. Od ledna 2018 do června 2022 předsedala Národní rozpočtové radě, v letech 2014 až 2018 působila také jako hlavní ekonomka České bankovní asociace. Od roku 2022 je opět členkou bankovní rady ČNB a od července 2022 působí také jako viceguvernérka ČNB.\u2028\u2028\u2028\uD83D\uDD57 Časová osa\u2028\u20280:00 Partner pořadu.\u20280:19 Viceguvernérka České národní banky.\u202801:43 Jaký vliv má reálně ČNB na cenu nemovitostí.\u202804:38 Vlastní bydlení v dnešní době a úrokové sazby.\u202806:40 Výběr do bankovní rady.\u202808:35 Zodpovědnost Evy Zamrazilové.\u202810:54 Budou se letos snižovat úrokové sazby?\u202814:07 Mzdové tarify.\u202815:05 Inflace\u202818:04 Smysl České národní banky.\u202819:59 Proinflační fiskální politika.\u202821:24 Rozpočtová odpovědnost a vliv na inflaci.\u202824:48 Kvantitativní uvolňování\u202825:54 Budou se zvyšovat daně a proč?\u202827:42 Daň z nemovitosti část I.\u202828:48 Rozpočtové omezení.\u202830:21 Vysoká cena nemovitostí.\u202830:54 Sčítání lidu, domů a bytů.\u202833:27 Daň z nemovitosti část II.\u202834:33 Vyplatí se penzijní spoření?\u202837:25 Jak vyzrát na penzijní spoření? :)\u202838:14 Posun věku odchodu do důchodu. Půjdeme do důchodu ve 120ti letech?\u202841:20 Umělá inteligence a budoucnost.\u202842:40 Jak se Česká republika ekonomicky vyvíjí v rámci západních zemí.\u202847:27 Devizové rezervy v současnosti. \u202851:15 Jak vnímá bitcoin a kryptoměny Eva Zamrazilová.\u202851:55 Přechod na patreon.\u2028\u2028\u2028\uD83D\uDD17 Odkazy\u2028\u202802:06 https://cc.cz/author/vojta-zizka/\u202828:50    • VLASTNÍ 150 BYTŮ ...  \u202848:44 https://www.cnb.cz/cs/o_cnb/cnblog/Ja...\u2028\u2028\u2028\uD83C\uDFA5 Produkce\u2028\u2028\uD83D\uDC69\u200D\uD83E\uDDB0 Marcela Drobná https://www.instagram.com/animacina/\u2028\uD83D\uDC68 Martin Janeš https://www.instagram.com/themartinja...\u2028\uD83D\uDC68 Jiří Hořice https://www.linkedin.com/in/JiriHorice\u2028\u2028\u2028⚠️ Disclaimer\u2028\u2028Veškerá má tvorba slouží pouze ke studijním účelům. Není investičním poradenstvím, doporučením a také není nabídkou či výzvou k nákupu či prodeji finančních nástrojů. Mějte na paměti, že při investování či spekulaci s finančními instrumenty, hrozí ztráta části či všech finančních prostředků.",
) {
    Column(
        Modifier.fillMaxWidth().padding(leftRight = SpaceLarge, topBottom = SpaceSmall)
    ) {
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            SpanText(
                date,
                SubTitleStyle.toModifier().fillMaxWidth().whiteSpace(WhiteSpace.NoWrap).fontSize(0.75.cssRem).color(state.textSecondaryRgbColor)
            )
            Space(modifier = Modifier.fillMaxWidth())
            SvgImage(width = 40.px, icon = Resources.Icons.ic_dots, color = state.iconPrimaryHexColor)
        }
        SpanText(
            title,
            SubTitleStyle.toModifier().fillMaxWidth().fontWeight(FontWeight.Bold).color(state.textPrimaryHexColor).textEllipsis(2)
        )
        SpanText(
            description,
            SubTitleStyle.toModifier().fillMaxWidth().whiteSpace(WhiteSpace.NoWrap).fontSize(14.px).color(state.textSecondaryRgbColor).textEllipsis(3)
        )
        Space(SpaceSmall)
        AudioPlayRowItem(state.iconPrimaryHexColor, 1, 24)
        Space(SpaceSmall)
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            CommentsCount(iconColor = state.iconPrimaryHexColor, textColor = state.textSecondaryRgbColor, Random(100).nextInt(2, 100))
            Space(SpaceSmall)
            ReactionsCount(textColor = state.textSecondaryRgbColor, state.reactionEmojiUnicode, Random(100).nextInt(2, 10_000))
        }
        SimpleDivider(color = state.separatorRgbColor)
    }
}

@Composable
private fun AudioPlayRowItem(color: String, hours: Int, minutes: Int) {
    Row(Modifier.fillMaxWidth().gap(SpaceXSmall), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.End) {
        SpanText(
            "${hours}h ${minutes}m",
            SubTitleStyle.toModifier().fontSize(0.75.cssRem).fontWeight(FontWeight.SemiBold).color(color).whiteSpace(WhiteSpace.NoWrap)
        )
        Box(Modifier.size(24.px).clip(Circle()).styleModifier { background(color) }, contentAlignment = Alignment.Center) {
            SvgImage(24.px, 24.px, Resources.Icons.ic_play_simple, ColorUtils.toHex(MainColors.white), maskSize = 16)
        }
    }
}

@Composable
private fun CommentsCount(iconColor: String, textColor: Color.Rgb, count: Int) {
    Row(Modifier.gap(SpaceXSmall), verticalAlignment = Alignment.CenterVertically) {
        SvgImage(width = 24.px, icon = Resources.Icons.ic_comment_active, color = iconColor)
        SpanText(
            count.toString(), SubTitleStyle.toModifier().color(textColor).fontSize(14.px)
        )
    }
}

@Composable
private fun ReactionsCount(textColor: Color.Rgb, emojiUnicode: String, count: Int) {
    Row(Modifier.gap(SpaceXSmall), verticalAlignment = Alignment.CenterVertically) {
        SpanText(
            emojiUnicode, SubTitleStyle.toModifier().fontSize(14.px)
        )
        SpanText(
            count.toString(), SubTitleStyle.toModifier().color(textColor).fontSize(14.px)
        )
    }
}

@Composable
private fun TagsRowView(state: MobileTemplateSampleState) {
    if (state.creatorTags.isNotEmpty()) {
        Box(modifier = Modifier.fillMaxWidth().overflow(Overflow.Auto)) {
            Row(
                Modifier.width(1000.px).overflowX(Overflow.Scroll).padding(left = SpaceMedium, top = SpaceMedium, bottom = SpaceMedium),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                state.creatorTags.forEach {
                    val props = CreatorPostTagViewProps.Simple(it, onClick = { })
                    CreatorPostTagView(props, modifier = Modifier)
                    Space(SpaceSmall)
                }
            }
        }
    }
}

@Composable
private fun PropRowView(state: MobileTemplateSampleState, icon: String, text: String) {
    Row(
        Modifier.padding(leftRight = SpaceSmall, topBottom = SpaceXSmall).borderRadius(RadiusMedium)
            .backgroundColor(MainColors.transparentBackground),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
//                    Object(attrs = {
//                        id("svgObject")
//                        attr("data", Resources.Icons.ic_subscriber_filled)
//                        attr("type", "image/svg+xml")
//                    }) {
//
//                    }
//                    SideEffect {
//                        document.getElementsByTagName("svg")[0]?.setAttribute(
//                            "fill",
////                                state.iconPrimaryHexColor
//                            "rgb(97, 255, 243)"
//                        )
//                    }


        SvgImage(icon = icon, color = state.iconPrimaryHexColor, maskSize = 20)
        Space()
        SpanText(
            text, SubTitleStyle.toModifier().fillMaxWidth().fontWeight(FontWeight.Medium).color(state.textSecondaryRgbColor)
        )
    }
}

@Composable
private fun StatusBarView() {
    Column(Modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally) {
        Space()
        Row(
            Modifier.fillMaxWidth().padding(SpaceSmall), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.Center
        ) {
            SpanText(
                "9:41", NormalTextStyle.toModifier().fillMaxWidth().textAlign(TextAlign.Center).color(MainColors.white).fontWeight(FontWeight.Bold)
            )
            Box(Modifier.fillMaxWidth().minWidth(50.px).height(24.px).borderRadius(RadiusXXXLarge).backgroundColor(MainColors.black))
            Row(
                Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.Center
            ) {
                FaSignal(Modifier.color(MainColors.white), size = IconSize.SM)
                Space()
                FaWifi(Modifier.color(MainColors.white), size = IconSize.SM)
                Space()
                FaBatteryHalf(Modifier.color(MainColors.white), size = IconSize.SM)
            }
        }
        Space()
    }
}